
import { useState, useEffect } from "react";
import { Channel } from "@/lib/types";

export function useTemporaryChannel(channel: Channel | null) {
  const [expiryTime, setExpiryTime] = useState<string | null>(null);

  // Calculate expiry time for temporary channels
  useEffect(() => {
    if (channel?.isTemporary && channel.autoDeleteAfter) {
      const createdDate = new Date(channel.createdAt);
      const expiryDate = new Date(createdDate.getTime() + (channel.autoDeleteAfter * 60 * 60 * 1000));
      
      // Check if not expired yet
      if (expiryDate > new Date()) {
        const updateTimer = () => {
          const now = new Date();
          const timeLeft = expiryDate.getTime() - now.getTime();
          
          if (timeLeft <= 0) {
            setExpiryTime("Expired");
            return;
          }
          
          const hours = Math.floor(timeLeft / (1000 * 60 * 60));
          const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
          
          setExpiryTime(`${hours}h ${minutes}m remaining`);
        };
        
        updateTimer();
        const timer = setInterval(updateTimer, 60000); // Update every minute
        
        return () => clearInterval(timer);
      } else {
        setExpiryTime("Expired");
      }
    }
  }, [channel]);

  return {
    expiryTime
  };
}
